"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _styles2 = require("../utilities/styles");
var _button = _interopRequireDefault(require("../button"));
var _excluded = ["children", "classes", "isActive", "fontFamily"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var useClasses = (0, _styles.makeStyles)(function (_ref) {
  var _root, _isActive;
  var palette = _ref.palette,
    breakpoints = _ref.breakpoints,
    spacing = _ref.spacing,
    highContrast = _ref.accessibility.highContrast,
    fontFamily = _ref.fontFamily;
  return {
    root: (_root = {
      color: palette.site.mobile.contrastText
    }, (0, _defineProperty2.default)(_root, breakpoints.up('md'), {
      color: palette.site.contrastText
    }), (0, _defineProperty2.default)(_root, "fontFamily", function fontFamily(_ref2) {
      var fontFamilyArray = _ref2.fontFamilyArray;
      return fontFamilyArray.join(", ");
    }), _root),
    isActive: (_isActive = {
      color: palette.site.mobile.activeText
    }, (0, _defineProperty2.default)(_isActive, breakpoints.up('md'), {
      color: palette.site.activeText
    }), (0, _defineProperty2.default)(_isActive, highContrast.mediaQuery('active'), {
      color: 'HighlightText !important',
      background: 'Highlight !important',
      padding: spacing(2),
      '-ms-high-contrast-adjust': 'none',
      '&:focus,&:hover': {
        color: 'HighlightText !important'
      }
    }), _isActive)
  };
}, {
  classNamePrefix: 'TCUISiteMenuItem'
});
var MenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
    classes = _ref3.classes,
    isActive = _ref3.isActive,
    fontFamily = _ref3.fontFamily,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var fontFamilyArray = ["Arial", "sans-serif"];
  if (fontFamily !== 'bahnschrift') {
    fontFamilyArray.unshift('"bahnschrift"');
    fontFamilyArray.unshift(fontFamily);
  } else {
    fontFamilyArray.unshift('"bahnschrift"');
  }
  var _classes = useClasses({
    fontFamilyArray: fontFamilyArray,
    fontFamily: fontFamily
  });
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, rest, {
    ref: ref,
    classes: (0, _styles2.mergeClasses)({
      root: (0, _clsx2.default)(_classes.root, (0, _defineProperty2.default)({}, _classes.isActive, isActive))
    }, classes)
  }), children);
});
MenuItem.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.object,
  isActive: _propTypes.default.bool,
  fontFamily: _propTypes.default.string
};
MenuItem.defaultProps = {
  children: null,
  classes: {},
  isActive: false,
  fontFamily: '"bahnschrift"'
};
var _default = MenuItem;
exports.default = _default;